import { createSettingValue } from './setting-value-impl';
export const createScoppedSetting = (target, name, tupleWasm, configWasm, globalTuple, defaultTuple) => {
    return new ScopedSettingImpl({ target, name }, tupleWasm, configWasm, globalTuple, defaultTuple);
};
class ScopedSettingImpl {
    settingFullName;
    tupleWasm;
    configWasm;
    globalTuple;
    defaultTuple;
    constructor(settingFullName, tupleWasm, configWasm, globalTuple, defaultTuple) {
        this.settingFullName = settingFullName;
        this.tupleWasm = tupleWasm;
        this.configWasm = configWasm;
        this.globalTuple = globalTuple;
        this.defaultTuple = defaultTuple;
    }
    fullName() {
        return this.settingFullName;
    }
    global() {
        return this.globalTuple ? createSettingValue(this.globalTuple, this.tupleWasm, this.configWasm) : undefined;
    }
    default() {
        return createSettingValue(this.defaultTuple, this.tupleWasm, this.configWasm);
    }
    effective() {
        return this.global() ?? this.default();
    }
}
